
const mutations = {
  setListCategory: (state, payload) => {
    state.listCategory = payload
  },
  setListCountry: (state, payload) => {
    state.listCountry = payload
  },
  setListCity: (state, payload) => {
    state.listCity = payload
  },
  setListNeighborhood: (state, payload) => {
    state.listNeighborhood = payload
  },
  setListLevelExprerience: (state, payload) => {
    state.listLevelExprerience = payload
  },
  setDetailJob: (state, payload) => {
    state.jobDetail = payload
  },
  setJobDetailNew: (state, payload) => {
    state.jobDetailNew = payload
  }
}
export default mutations
